import MultipleChoiceInputs from "pages/QuestionPage/questionCreation/MultipleChoiceInputs/MultipleChoiceInputs";

export default MultipleChoiceInputs;
